export const METRICS_SUCCESS_LOGIN = 'login';
export const METRICS_LOGIN_METHOD = 'Method';
export const METRICS_LOGIN_METHOD_SMS = 'SMS';

//Community Profile Metrics
export const METRICS_PROFILE_ACCESS = 'community_profile_access';
export const METRICS_COMMUNITY_EDIT_PERSONAL_INFO = 'community_edit_caregiver';
export const METRICS_COMMUNITY_EDIT_FIRST_NAME = 'community_edit_first_name';
export const METRICS_COMMUNITY_EDIT_LAST_NAME = 'community_edit_last_name';
export const METRICS_COMMUNITY_EDIT_LOCATION = 'community_edit_location';
export const METRICS_COMMUNITY_EDIT_INTERESTS = 'community_edit_interests';
export const METRICS_COMMUNITY_INTERESTS_LIST = 'community_interests_list';
export const METRICS_COMMUNITY_PROP_MEMBER = 'community_member';
export const METRICS_COMMUNITY_WITHDRAW_MENU_CLICK =
  'community_withdraw_menu_click';
export const METRICS_COMMUNITY_WITHDRAW_MENU_ITEM_CLICK =
  'community_withdraw_menu_item_click';
export const METRICS_COMMUNITY_WITHDRAW = 'community_withdraw';
export const METRICS_COMMUNITY_WITHDRAW_CANCEL = 'community_withdraw_cancel';

//Community Metrics
export const METRICS_COMMUNITY_ACCESS = 'community_access';
export const METRICS_COMMUNITY_CONNECTIONS_ACCESS =
  'community_connections_access';
export const METRICS_COMMUNITY_CONNECTION_CANCEL_PENDING =
  'community_cancel_pending_connection';
export const METRICS_COMMUNITY_CONNECTION_REMOVE =
  'community_remove_connection';

export const METRICS_COMMUNITY_ACTIVITY_ACCESS_SOURCE = 'Source';
export const METRICS_COMMUNITY_ACTIVITY_ACCESS_SOURCE_SIDE_BAR = 'Side Bar';
export const METRICS_COMMUNITY_OPT_OUT = 'community_opt_out';

export const METRICS_EVENT_ACTIVITY_ACCESS = 'event_activity_access';
export const METRICS_EVENT_ACTIVITY_FILTER = 'event_activity_filter';
export const METRICS_ARTICLE_ACTIVITY_ACCESS = 'article_activity_access';
export const METRICS_SAVED_ARTICLES_ACTIVITY_ACCESS =
  'saved_articles_activity_access';
export const METRICS_SAVED_EVENTS_ACTIVITY_ACCESS =
  'saved_events_activity_access';

//Articles related metrics
export const METRICS_ARTICLES_ACTIVITY_ACCESS = 'articles_activity_access';
export const METRICS_ARTICLES_ACCESS = 'article_access';
export const METRICS_ARTICLE_SAVED = 'article_saved';
export const METRICS_ARTICLE_UNSAVED = 'article_unsave';
export const METRICS_ARTICLES_READ = 'article_read';
export const METRICS_ARTICLES_ACCESS_COUNT = 'article_access_ct';
export const METRICS_ARTICLES_READ_COUNT = 'article_read_ct';
export const METRICS_ARTICLES_SAVED_COUNT = 'articles_saved_ct';

//Article Properties
export const METRICS_ARTICLES_PROPERTY_TITLE = 'Title';
export const METRICS_ARTICLES_PROPERTY_AUTHORSHIP = 'Authorship';
export const METRICS_ARTICLES_PROPERTY_TAG = 'Tags';
export const METRICS_ARTICLES_PROPERTY_SOURCE = 'Source';
export const METRICS_ARTICLES_PROPERTY_CATEGORIES = 'Categories';
export const METRICS_ARTICLES_PROPERTY_SOURCE_HOME_PAGE = 'Home Activity';
export const METRICS_ARTICLES_PROPERTY_SOURCE_ARTICLES_PAGE =
  'Articles Activity';
export const METRICS_ARTICLES_PROPERTY_SOURCE_SAVED_PAGE =
  'Saved Articles activity';
export const METRICS_ARTICLES_PROPERTY_SOURCE_EMBEDDED = 'Embedded Article';
export const METRICS_ARTICLES_PROPERTY_SOURCE_ARTICLE_POST = 'Article Post';
export const METRICS_ARTICLES_PROPERTY_SOURCE_RESOURCES = 'Resources';
export const METRICS_ARTICLES_PROPERTY_SOURCE_SIDE_BAR = 'Side Bar';

//Events related metrics
export const METRICS_EVENTS_ACTIVITY_ACCESS = 'events_activity_access';
export const METRICS_EVENTS_ACCESS = 'event_access';
export const METRICS_EVENTS_PUSH_ACCESS = 'event_push_notification_access';
export const METRICS_EVENTS_ACCESS_COUNT = 'event_access_ct';
export const METRICS_EVENTS_SAVED_COUNT = 'events_saved_ct';

export const METRICS_EVENT_SAVED = 'event_saved';
export const METRICS_EVENT_UNSAVED = 'event_unsave';
//Events Properties
export const METRICS_EVENTS_PROPERTY_NAME = 'Name';
export const METRICS_EVENTS_PROPERTY_ORGANIZER = 'Organizer';
export const METRICS_EVENTS_PROPERTY_DATE = 'Date';
export const METRICS_EVENTS_PROPERTY_TIME = 'Time';
export const METRICS_EVENTS_PROPERTY_LOCATION = 'Location';
export const METRICS_EVENTS_PROPERTY_COST = 'Cost';
export const METRICS_EVENTS_PROPERTY_TAG = 'Tag';
export const METRICS_EVENTS_PROPERTY_SOURCE = 'Source';
export const METRICS_EVENTS_PROPERTY_SOURCE_HOME_PAGE = 'Home Activity';
export const METRICS_EVENTS_PROPERTY_SOURCE_EVENT_PAGE = 'Event Activity';
export const METRICS_EVENTS_PROPERTY_SOURCE_SAVED_PAGE =
  'Saved Events Activity';
export const METRICS_EVENTS_PROPERTY_SOURCE_EVENT_POST = 'Event Post';
export const METRICS_EVENTS_PROPERTY_SOURCE_SIDE_BAR = 'Side Bar';
export const METRICS_EVENTS_PROPERTY_SOURCE_RESOURCES = 'Resources';
export const METRICS_EVENTS_PROPERTY_CATEGORY = 'Event Category';

//Saved related metrics
export const METRICS_SAVED_ACTIVITY_ACCESS = 'saved_activity_access';

// Dimension metrics
export const METRICS_DIM_ACTIVITY_ACCESS = 'dimension_activity_access';
export const METRICS_DIM_ACCESS = 'dimension_access';
export const METRICS_DIM_VIDEO_PLAY = 'dimension_play_video';
export const METRICS_DIM_PROPERTIES_SOURCE = 'Source';
export const METRICS_DIM_PROPERTIES_SOURCE_SIDE_BAR = 'Side Bar';
export const METRICS_DIM_PROPERTIES_SOURCE_RESOURCES = 'Resources';
export const METRICS_DIM_VIDEO_NAME = 'Video Name';

//Messages Metrics
export const METRICS_MESSAGES_ACCESS = 'messages_access';
export const METRICS_MEDIA_MESSAGE_CLICK = 'media_message_click';
export const METRICS_FILE_MESSAGE_CLICK = 'file_message_click';
export const METRICS_EXPAND_MESSAGING_VIEW = 'expand_messaging_view';
export const METRICS_COLLAPSE_MESSAGING_VIEW = 'collapse_messaging_view';
export const METRICS_MESSAGES_MEMBERS_ACCESS = 'messages_members_access';

//Account Settings Metrics
export const METRICS_ACCOUNT_CHANGE_LANGUAGE = 'change_language';
export const METRICS_ACCOUNT_LANGUAGE = 'Language';
export const METRICS_SIGN_OUT = 'sign_out';
export const METRICS_SUPPORT_EMAIL = 'support_email';

//Notifications related
export const METRICS_ARTICLES_NOTIFICATIONS = 'notif_articles';
export const METRICS_EVENTS_NOTIFICATIONS = 'notif_events';
export const METRICS_CARE_TEAM_NOTIFICATIONS = 'notif_care_team';
export const METRICS_COMMUNITY_NOTIFICATIONS = 'notif_community';
export const METRICS_ANNOUNCEMENTS_NOTIFICATIONS = 'notif_announcements';

//survey related metrics
export const METRICS_SURVEY_PSS_ACTIVITY_ACCESS = 'survey_pss_activity_access';
export const METRICS_SURVEY_CLIENT_PACKET_ACTIVITY_ACCESS =
  'survey_client_packet_activity_access';
export const METRICS_SURVEY_CSAT_ACTIVITY_ACCESS =
  'survey_csat_activity_access';
export const METRICS_SURVEY_PSS_ACTIVITY_COMPLETE =
  'survey_pss_activity_complete';
export const METRICS_SURVEY_CLIENT_PACKET_ACTIVITY_COMPLETE =
  'survey_client_packet_activity_complete';
export const METRICS_SURVEY_CSAT_ACTIVITY_COMPLETE =
  'survey_csat_activity_complete';
